import { InfoWindow } from "@vis.gl/react-google-maps";
import { createPortal } from "react-dom";
import PinDropIcon from "@mui/icons-material/PinDrop";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import CloseIcon from "../../../CloseIcon";
import { useNitroStore } from "../../../../store/Store";
import "./index.css";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import NitroLargeIcon from "./components/NitroLargeIcon";
import { NitroMarkerBase } from "../NitroMarker";

const PopupContents = () => {
  const [
    showInsightsPanel,
    selectedLocation,
    setSelectedLocation,
    setTempPinLocation,
    selectedLocationLatLng,
    setSelectedLocationLatLng,
    openInsightsPanel,
    setShowMapPopup,
    setAddLocationDetails,
    setShowAddLocationPanel,
  ] = useNitroStore((states) => [
    states.showInsightsPanel,
    states.selectedLocation,
    states.setSelectedLocation,
    states.setTempPinLocation,
    states.selectedLocationLatLng,
    states.setSelectedLocationLatLng,
    states.openInsightsPanel,
    states.setShowMapPopup,
    states.setAddLocationDetails,
    states.setShowAddLocationPanel,
  ]);

  if (!selectedLocation || showInsightsPanel) {
    return null;
  }

  if (!selectedLocationLatLng) return null;

  return (
    <div>
      <div
        id="popup-id"
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 20,
          borderBottom: "1px solid #d9d9d9",
          paddingTop: 0,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            flexGrow: 1,
            paddingLeft: 20,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="popupTitle">{selectedLocation.name}</div>

          <div style={{ display: "flex", gap: 0, alignItems: "center" }}>
            <NitroMarkerBase width={24} type={selectedLocation.pinType} />
            <div className="popupSubTitle">{selectedLocation.city}</div>
          </div>
        </div>

        <div
          style={{
            padding: "0px 20px",
            paddingLeft: 0,
            height: "100%",
          }}
        >
          <CloseIcon
            onClick={() => {
              setShowMapPopup(false);
              setSelectedLocation(undefined);
              setSelectedLocationLatLng(undefined);
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 20,
          padding: "20px 30px",
          paddingLeft: 25,
        }}
      >
        {selectedLocation.pinType !== "zipCodes" && (
          <NitroLargeIcon
            variant="outlined"
            label="Location Overview"
            icon={<PinDropIcon style={{ color: "#005CA6", fontSize: 30 }} />}
            onClick={() => {
              const targetLat = Number(
                selectedLocationLatLng?.lat ?? selectedLocation.lat,
              );
              const targetLng = Number(
                selectedLocationLatLng?.lng ?? selectedLocation.long,
              );
              setTempPinLocation({
                lat: targetLat,
                lng: targetLng,
              });
              setShowMapPopup(false);
              openInsightsPanel(selectedLocation.id, "Logistics", false);
            }}
          />
        )}
        {selectedLocation.pinType === "zipCodes" && (
          <NitroLargeIcon
            variant="outlined"
            label="Add Location"
            icon={
              <AddLocationAltIcon style={{ color: "#005CA6", fontSize: 30 }} />
            }
            onClick={() => {
              setAddLocationDetails({
                zipCode: selectedLocation.id,
                cityState: selectedLocation.city,
              });
              setShowAddLocationPanel(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

const Popup = () => {
  const isMobile = useIsMobile(768);
  const [
    showInsightsPanel,
    selectedLocation,
    selectedLocationLatLng,
    showMapPopup,
  ] = useNitroStore((state) => [
    state.showInsightsPanel,
    state.selectedLocation,
    state.selectedLocationLatLng,
    state.showMapPopup,
  ]);

  if (!selectedLocation || !showMapPopup || showInsightsPanel) {
    return null;
  }

  if (!selectedLocationLatLng) return null;

  if (isMobile) {
    return createPortal(
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10002,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: 10,
            boxShadow: "0px -4px 20px rgba(0, 0, 0, 0.2)",
          }}
        >
          <PopupContents />
        </div>
      </div>,
      document.body,
    );
  }

  return (
    <InfoWindow position={selectedLocationLatLng}>
      <PopupContents />
    </InfoWindow>
  );
};

export default Popup;
